// extracted by mini-css-extract-plugin
export default {"snackbar":"Notification_snackbar__TZgj5","snackbar2":"Notification_snackbar2__zX14a"};